import { useEffect, useState } from 'react'
import { observeUnreadNotificationsCount } from '@domain/features/user-notifications/user-notifications-feature'

export function useUnreadNotificationsCount(userId: string | undefined) {
  const [count, setCount] = useState(0)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setError(null)

    if (!userId) {
      setCount(0)
      return
    }

    let cancelled = false
    const unsubscribe = observeUnreadNotificationsCount(
      (nextCount) => {
        if (cancelled) {
          return
        }
        setCount(nextCount)
      },
      (nextError) => {
        if (cancelled) {
          return
        }
        setError(nextError.message)
      },
      userId,
    )

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [userId])

  return {
    count,
    error,
  }
}
